import * as React from "react"
import { ChangeEvennt } from "react"
import { connect } from "react-redux"
import TextInput from "../TextInput";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import { map as _map, isEmpty as _isEmpty, get as _get, isNull as _isNull, isEqual as _isEqual } from "lodash";
import { IAppState } from "../../models/IAppState";
import { GenericActions } from "../../actions/GenericActions";
import { ModalActions } from "../../actions/ModalActions";
import TextAreaAutoResize from "../../components/TextAreaAutoResize";
import SuggestionTagsContainer from "../../containers/SuggestionTagsContainer";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import IQuestionnaire, { Question } from "../../models/util/IQuestionnaire";
import ISelect from "../../../../common/models/ISelect";
import { AppConstants, DOCTOR_TYPES_FOR_APPOINTMENT, QuestionType, FieldTypes, SEQUENTIAL_RECOMMENDATIONS_SECTIONS } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import { EventNames, SectionContext } from "../../utils/EventTrackerConstants";
import IFrequency from "../../../../common/models/IFrequency";
import { Tracker } from "../../utils/Tracker";
import ValidationUtils from "../../../../common/utils/ValidationUtils";
import AdvancedDurationComponent from "../AdvancedDurationComponent";
import InputWithDropDownComponent from "../common/InputWithDropDownComponent";
import Questionnaire, { MetaData } from "../common/Questionnaire";
import { SuggestionList } from "../common/SuggestionList";
import { RenderLabel, SpacingArea } from "../common/ToggleSelect";
import ToggleSwitch from "../common/ToggleSwitch";
import CustomSelect from "../CustomSelect";
import Frequency from "../DurationComponent";
import GoalChartComponent from "../GoalChartComponent";
import HorizontalTagsListView from "../HorizontalTagsListView";
import TemplatedList from "../TemplatedList";
import ToggleList, { default as ToggleButtonList } from "../ToggleButtonList";
import WeekdaySelector from "../WeekdaySelector";
import { IMetricData } from "@curefit/metrics-common";
import { RouteComponentProps, withRouter } from "react-router";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { MedicineFrequencyType } from "../../models/Consultation";
import { LoaderConsumer } from "../../context/loadingContext";
import AppLoader from "../utils/AppLoader";
import * as _ from "lodash";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";

export interface GenericItemElement {
    value: string,
}

interface MatchParams {
    consultationId: number,
    patientId: number
}

interface IGenericItemEditorDispatchProps {
    updateModalUIConfig: (formattedConfigAvailable: boolean) => void;
    getTypeAheadData: (name: string, typeAheadConfig: any, shouldSendOverridenData?: boolean) => Promise<any>;
}

interface IGenericItemEditorStateToProps {
    ongoingConsultation: IOngoingConsultation;
}

export interface IGenericItemEditorProps extends Partial<RouteComponentProps<MatchParams, MatchParams>> {
    question?: IQuestionnaire;
    item?: any;
    items?: any;
    validations?: any;
    fields: any;
    onDataChange?: (update: any) => any;
    patientMetrics?: { [metricId: number]: IMetricData[] };
    disableFields?: boolean;
    validator?: any;
    value?: string | number;
    validationText?: any;
    location?: Location;
    templateIndex?: number;
    showHeaderOnFields?: boolean,
    isViewOnly?: boolean;
    validationHandler?: (value: any) => void;
    saveHandler?: (data: any) => void,
    templateKey?: any;
    supportDecimal?: boolean;
    isDeactivated?: boolean;
    className?: string;
    fetchPatientPastSessions?: (patientId: number, subSectionKey: string) => Promise<any>;
    onAddNewItem?: (patientId: number, subSectionKey: string) => void;
    patientId?: number;
    subSectionKey?: string;
    addSymptomForReview?: (name: string) => Promise<any>;
    columnIndex?: number;
    addButtonClicked?: (status: boolean, name: string) => Promise<any>;
    responseData?: any;
    modalResponse?: any;
    complaints?: any,
    modalHeaders?: string[];
    index?: number;
    isDefault?: boolean;
    basic?: any;
    onDataSelect?: (updatedItem: any) => void;
    router?: any,
    widgetName?: string
    metaData?: MetaData
}

export interface IGenericItemEditorState {
    validate: boolean;
    getValidation: boolean;
    ValidTypeAheadSelection: boolean;
    typeAheadValue: string;
    isActiveMedicationVisible: boolean;
    validSelections: any[];
    selectedValuesInMultiSelect: any[];
    tempValue: string;
    getList: any[]
}

class GenericItemEditor extends React.Component<IGenericItemEditorProps & IGenericItemEditorDispatchProps & IGenericItemEditorStateToProps, IGenericItemEditorState> {

    constructor(props: IGenericItemEditorProps & IGenericItemEditorDispatchProps & IGenericItemEditorStateToProps) {
        super(props)
        this.state = {
            validate: false,
            typeAheadValue: "",
            isActiveMedicationVisible: true,
            getValidation: true,
            ValidTypeAheadSelection: false,
            validSelections: props.basic && props.basic.complaints || [],
            selectedValuesInMultiSelect: [],
            getList: [],
            tempValue: "intitalValue"

        }
    }

    static contextType = SectionContext;

    onTypeAheadBlur = (event: any, field: any, item: any) => {
        if (!event.target.value || this.state.validSelections.indexOf(event.target.value) > -1) {
            return;
        }
        else {
            // if event.target.value exists in state.validselection, do nothing(means return;)
            try {
                if (field.typeAheadConfiguration.allowAddItem === true && !this.state.ValidTypeAheadSelection) {
                    this.props.basic && this.props.basic.onAddNewItem && this.props.basic.onAddNewItem(this.props.basic.patientId, this.props.basic.subSectionKey, event.target.value);
                }
            } catch (error) {
                console.log("Error")
            }
        }
    }

    captureKeyPress(event: any) {
        try {
            if (this.props.basic.responseData === false) {
                this.props.basic && this.props.basic.onAddNewItem && this.props.basic.onAddNewItem(this.props.basic.patientId, this.props.basic.subSectionKey, event.target.value);
            }

        } catch (error) {
            console.log("getLog")
        }

    }

    onTypAheadChange = (input: string, field: any): Promise<any> => {
        if (this.props.basic.responseData && this.props.basic.responseData === false) {
            this.props.basic && this.props.basic.onAddNewItem && this.props.basic.onAddNewItem(this.props.basic.patientId, this.props.basic.subSectionKey);
        }
        let updatedItem = { ...this.props.item, validSelection: false }
        if (field.key) {
            updatedItem[field.key] = { displayValue: input, internalValue: input }
        }
        if (field.displayKey) {
            updatedItem[field.displayKey] = { displayValue: input, internalValue: input }
        }
        this.props.onDataChange(updatedItem);
        let linkedFieldKeys = field.linkedFieldKeys;
        let { valueKey, internalKey, code, labelKey, additionalInfoLabelKeys, otherKeysMapping } = field.typeAheadConfiguration;
        // field.typeAheadConfiguration.additionalParams = otherKeysMapping;

        // this hardcoding is for adhoc testing of search improvement by directly sending params to elastic search
        // this should be removed later
        let shouldSendOverridenData: boolean = false;
        if (this.props.ongoingConsultation && this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.doctorType === DOCTOR_TYPES_FOR_APPOINTMENT.GP) {
            shouldSendOverridenData = true;
        }

        return this.props.getTypeAheadData(input, field.typeAheadConfiguration, shouldSendOverridenData).then(resultList => {
            let allergenTypeAhead: TypeAheadElement[] = [];

            // code responsible for concatenating the label key with the value in the additionalInfoLabelKeys with pipe(|)
            _map(resultList, (obj) => {
                let additionalInfoLabel = (additionalInfoLabelKeys || []).reduce((attribute: any[], key: string) => {
                    obj[key] && attribute.push(obj[key]);
                    return attribute;
                }, [])
                    .join(" | ")
                let others: any = {};
                let linkedFields: any = {};
                if (linkedFieldKeys) {

                    linkedFieldKeys.forEach((field: any) => {
                        if (!_isEmpty(field.defaultValue)) {
                            linkedFields[field.key] = field.defaultValue;
                        } else {
                            switch (field["primaryType"]) {
                                case "object":
                                    if (obj[field["valueKey"]]) {
                                        linkedFields[field.key] = {
                                            displayValue: obj[field["valueKey"]],
                                            internalValue: obj[field["valueKey"]]
                                        }
                                    }
                                    break
                                case "frequency":
                                    const key = obj[field["valueKey"]]
                                    if (key) {
                                        if (field["valueToUnitMap"]) {
                                            let unit = field["valueToUnitMap"][key];
                                            if (!_isEmpty(unit))
                                                linkedFields[field.key] = { count: field.countToUnitMap[key] || null, unit: unit }
                                        }
                                        else {
                                            linkedFields[field.key] = { count: 1, unit: obj[field["valueKey"]] }
                                        }
                                    }
                                    break
                                default:
                                    linkedFields[field.key] = obj[field["valueKey"]]
                            }
                        }
                    })
                }

                if (!_isEmpty(otherKeysMapping)) {
                    Object.keys(otherKeysMapping).map((key: string) => {
                        others[key] = obj[otherKeysMapping[key]];
                    });
                }

                let typeAheadElement: TypeAheadElement = {
                    value: obj[valueKey],
                    label: obj[labelKey],
                    internalKey: obj[internalKey],
                    code: obj[code],
                    additionalInfoLabel: additionalInfoLabel,
                    others: others,
                    linkedFields
                }
                allergenTypeAhead.push(typeAheadElement);
            });
            if (field.typeAheadConfiguration.allowAddItem) {
                let typeAheadElement: TypeAheadElement = {
                    value: input,
                    internalKey: input,
                    label: input,
                    additionalInfoLabel: field.typeAheadConfiguration.addItemToTypeahead.displayText,
                    addItem: true
                };
                allergenTypeAhead.push(typeAheadElement);
            }
            return Promise.resolve({ options: allergenTypeAhead, completed: true });
        }).catch(error => {
            console.log(error)
            return Promise.resolve({ options: "Failed to fetch results" });
        });
    }

    onTypeAheadSelect = (elem: TypeAheadElement, field: any, selectedIndex?: number, noOfKeystrokes?: number, searchKeyword: string) => {
        if (elem) {
            const updatingMethod = elem.addItem && field.typeAheadConfiguration.allowAddItem ? EventNames.Add_New : EventNames.Auto_Suggest
            Tracker.track(EventNames.Field_Added, {
                consultationId: this.props.router.params && this.props.router.params.consultationId, widget: this.props.widgetName,
                section: this.props.metaData && this.props.metaData.sectionKey, value: elem.label,
                rank: selectedIndex && selectedIndex + 1,
                updatingMethod: updatingMethod,
                noOfKeystrokes: noOfKeystrokes,
                searchKeyword: searchKeyword || ""
            })

            const itemDisplayValue = elem.value;
            const itemInternalValue = (Array.isArray(elem.internalKey)) ? elem.internalKey[0] : elem.internalKey;
            let updatedItem = { ...this.props.item, validSelection: true, updatingMethod: updatingMethod };
            if (field.key) {
                updatedItem[field.key] = { displayValue: itemDisplayValue, internalValue: itemInternalValue, additionalInfo: elem && elem.others && elem.others.prescribableProducts };
            }
            if (field.displayKey) {
                updatedItem[field.displayKey] = { displayValue: itemDisplayValue, internalValue: elem.internalKey }
            }
            if (elem.linkedFields) {
                updatedItem = { ...updatedItem, ...elem.linkedFields }
            }
            if (elem.code) {
                updatedItem.code = elem.code;
            }
            for (let key in elem.others) {
                if (updatedItem[key]) {
                    updatedItem[key] = elem.others[key];
                }
            }

            if (field.typeAheadConfiguration.allowAddItem) {
                this.setState((prevState: any) => {
                    return {
                        validSelections: [...prevState.validSelections, updatedItem[field.key].displayValue]
                    };
                })
            }

            if (this.props.isDefault) {
                this.props.onDataSelect(updatedItem);
            } else {
                this.props.onDataChange(updatedItem);
            }
        }
    }

    changeHandler = (event: React.SyntheticEvent<HTMLTextAreaElement>, field: any) => {
        const value = field.isObject && (event.target as HTMLTextAreaElement).value !== "" ? { displayValue: (event.target as HTMLTextAreaElement).value, internalValue: (event.target as HTMLTextAreaElement).value } : (event.target as HTMLTextAreaElement).value;
        let updatedItem = { ...this.props.item, [field.key]: value }
        let validations = { ...this.props.validations };
        validations = ValidationUtils.checkValidations(updatedItem, this.props.fields, "key")
        this.props.onDataChange(updatedItem);
        if (this.props.validationHandler)
            this.props.validationHandler(validations);
    }

    selectChangeHandler = (event: any, key: string) => {

        let updatedItem = { ...this.props.item, [key]: event.target.value }
        this.props.onDataChange(updatedItem);

    }

    onConditionSuggestionAdd = (suggestionItem: IStaticDataValue, field: any) => {
        let updatedItem = { ...this.props.item, [field.targetField]: { displayValue: suggestionItem.displayValue, internalValue: suggestionItem.internalKey }, [field.displayKey]: { displayValue: suggestionItem.displayValue, internalValue: suggestionItem.internalKey } }
        let selectedValue = updatedItem[field.targetField];
        let suggestionsList = field.filteredStaticConditions;
        let formattedSuggestionsList = suggestionsList.splice(selectedValue, 1);
        this.props.onDataChange(updatedItem);

    }

    onSuggestionAdd = (suggestionItem: IStaticDataValue, field: any, index: number) => {

        this.setState({
            validate: false,
            tempValue: "FinalValue"
        }, () => {
            console.log("STATE_UPDATED");
        })
        let updatedItem = {
            ...this.props.item, [field.targetField]:
            {
                displayValue: suggestionItem.displayValue,
                internalValue: suggestionItem.internalValue
            }, [field.displayKey]:
                { displayValue: suggestionItem.displayValue, internalValue: suggestionItem.internalValue }
        }
        let selectedValue = updatedItem[field.targetField];
        let suggestionsList = field.filteredStaticConditions;
        // let formattedSuggestionsList = suggestionsList.splice(selectedValue, 1);
        this.props.onDataChange(updatedItem);

    }

    onNumericChangeHandler = (event: any, key: string) => {
        let inputText = event.target.value;
        // let inputText = event.target.value.toString();
        if (!isNaN(Number(inputText))) {
            let value = inputText;
            let updatedItem = { ...this.props.item };
            updatedItem[key] = value;
            this.props.onDataChange(updatedItem);
        }
    }

    toggleHandler = (value: boolean, key: string) => {
        let updatedItem = { ...this.props.item, [key]: !value }
        this.props.onDataChange(updatedItem);
    }

    getListItems = (item: any) => {
        let listItems: { item: any }[] = [];
        _map(item.items && item.items, (item) => {
            listItems.push({ "item": item });
        })
        return listItems;
    }

    createDefaultItem = (field: any) => {
        let item: any = {};
        field.fields && field.fields.map((subItem: any, index: number) => {
            item[subItem.key] = ""
            if (subItem.displayKey) {
                item[subItem.displayKey] = ""
            }
        })
        return { item: item };
    }

    onCheckBoxChange = (event: ChangeEvent<HTMLInputElement>, key: string) => {
        let updatedItem = { ...this.props.item, [key]: event.target.checked }
        this.props.onDataChange(updatedItem)
    }

    handleDateChange = (date?: any) => {
        const formattedDate = AppUtils.isDefined(date) ? moment(date).utc().format() : moment().utc().format();
        let updatedItem = { ...this.props.item, recordedDate: formattedDate };
        this.props.onDataChange(updatedItem);
    }

    handleDateOnBlur = (e: any) => {
        const date: string = e.target.value;
        if (moment(date, AppConstants.reverseDateFormat).isValid()) return;
        else {
            this.handleDateChange();
        }
    }

    unitChangeHandler = (value: string, key: string) => {
        let updatedInfo = { ...this.props.item };
        updatedInfo[key] ? updatedInfo[key].unit = value : updatedInfo[key] = { unit: value };
        this.props.onDataChange(updatedInfo);
    }

    frequencyChangeHandler = (value: TypeAheadElement, key: string) => {
        let updatedInfo = { ...this.props.item };
        let validations = { ...this.props.validations };
        updatedInfo[key] = value && value.others.value;
        this.props.onDataChange(updatedInfo);
    }

    countChangeHandler = (e: any, key: string) => {
        let updatedInfo = { ...this.props.item };
        updatedInfo[key] ? updatedInfo[key].count = e.target.value : updatedInfo[key] = { count: e.target.value };
        this.props.onDataChange(updatedInfo);
    }

    updateHandler = (value: any, subkey: string, key: string) => {
        let updatedAnswer = { ...this.props.item, [subkey]: value };
        this.props.onDataChange(updatedAnswer);
    }

    allSelectToggleHandler = (values: any[], key: string, additionalArgs?: any) => {
        let updatedInfo = { ...this.props.item };
        updatedInfo[key] = this.props.isDefault ? values[0] : values;
        if (this.props.isDefault) {
            this.props.onDataSelect(updatedInfo);
        } else {
            this.props.onDataChange(updatedInfo);
        }
    }

    updateWeekdays = (values: string[], field: any) => {
        let fieldKey = field.key;
        let diagnosticActivity = { preferredWeekDays: values };
        let updatedItem = { ...this.props.item, [fieldKey]: [diagnosticActivity] };
        this.props.onDataChange(updatedItem);
    }

    onMultiSelectOptionsRemove = (field: any, index: number) => {
        let updatedValue = { ...this.props.item };
        updatedValue[field.key].splice(index, 1);
        this.props.onDataChange(updatedValue);
        this.setState(prev => {
            let prevValues = prev.selectedValuesInMultiSelect;
            prevValues.splice(index, 1);
            return {
                selectedValuesInMultiSelect: prevValues
            }
        })
    }

    handleMultiSelectTypeAheadChange = (input: any, field: any): Promise<any> => {
        this.setState({ typeAheadValue: input });
        return new Promise((resolve, reject) => {
            let options: TypeAheadElement[] = [];
            let others: any = {};
            field.options.forEach((obj: any) => {
                if (obj["label"].toLowerCase().includes(input.toLowerCase())
                    && (_isEmpty(this.props.item[field.key]) || this.props.item[field.key].map((i: any) => i.displayValue).indexOf(obj["label"]) === -1)) {
                    let typeAheadElement: TypeAheadElement = {
                        value: obj["value"],
                        label: obj["label"],
                        additionalInfoLabel: obj["value"],
                        others: others
                    }
                    options.push(typeAheadElement);
                }
            });
            resolve({ options: options, completed: true });
        })
    }

    booleanToggleHandler = (selectedBtn: any, key: string) => {
        let updatedInfo = { ...this.props.item };
        if (selectedBtn === null) {
            delete updatedInfo[key];
        }
        else {
            let answer = selectedBtn;
            updatedInfo[key] = answer;
        }
        this.props.onDataChange(updatedInfo);
    }

    generateChartRows = () => {
        let rowArray: any = [];
        if (AppUtils.isDefined(this.props.patientMetrics) && AppUtils.isDefined(this.props.patientMetrics[this.props.item.metricId as any])) {
            this.props.patientMetrics[this.props.item.metricId as any].forEach((metric: IMetricData, index: number) => {
                let date = new Date(metric.metricDate);
                let fullDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
                let item = [];
                // console.log("__DATE__", date.getMonth() + 1, date.getDate(), date.getFullYear());
                item.push(date.getMonth() + 1);
                item.push(metric.value);
                let hoverItem = `<div style="padding: 5px; min-width: 60px"><div style="font-size: 14px; font-weight: bold">${metric.value}</div><div style="font-size: 8px">${fullDate}</div></div>`;
                item.push(hoverItem);
                rowArray.push(item as any);
            })
        }
        return rowArray;
    }

    handleTypeAheadClick = (event: any, data: { inputType: string, inputValue?: string | number, field?: string }) => {
        if (this.props.basic?.handleListItemClick) {
            this.props.basic.handleListItemClick(event, data)
        }
    }

    handleTypeaheadSuggestionSelect = (value: string, field: Question) => {
        const elem = { value, label: value }
        this.onTypeAheadSelect(elem, field)
    }

    renderFieldTypeAhead = (field: any, index: number) => {
        let displayValue = this.props.item && typeof this.props.item[field.key] === "string" ? this.props.item[field.key] : this.props.item && this.props.item[field.key] && this.props.item[field.key].displayValue;
        try {
            if (!displayValue) typeof this.props.item === "string" ? displayValue = this.props.item : "";
        } catch (error) {

        }
        const suggestions: IStaticDataValue[] = (field.suggestions || []).map((item: string) => ({ displayValue: item, internalValue: item }))
        return <div className={"questionnaire-typeahead-wrapper"}>
            {!_.isEmpty(suggestions) && <div className={"cs-suggestions-container"}>
                <ToggleButtonList
                    type={QuestionType.BOOLEAN_TOGGLE}
                    handleTagsClick={(event, tagValue) => this.handleTypeAheadClick(event, { inputType: "Tags", inputValue: tagValue, field: field.key })}
                    listItems={suggestions}
                    selectedItems={[]}
                    onSelectionChange={(value) => this.handleTypeaheadSuggestionSelect(value as string, field)}
                />
            </div>}
            <TypeAhead
                widgetName={this.props.widgetName}
                name={field.key}
                value={displayValue || ""}
                onTypeAheadBlur={(e: any) => this.onTypeAheadBlur(e, field, this.props.item)}
                placeholder={field.placeholder}
                onTypeAheadChange={(input) => this.onTypAheadChange(input, field)}
                onTypeAheadSelect={(elem: TypeAheadElement, selectedIndex: number, noOfKeystrokes: number, event: any, searchKeyword: string) => this.onTypeAheadSelect(elem, field, selectedIndex, noOfKeystrokes, searchKeyword)}
                displayValue={displayValue}
                showSearchIcon={field.enableSearchIcon}
                highlightOn={field.typeAheadConfiguration.highlightOn}
                onClickHandler={(event, data) => this.handleTypeAheadClick(event, { ...data, field: field.key })}
            />
        </div>
    }


    renderDropdown = (field: any, index: number) => {
        let fieldDisplayValue = this.props.item && this.props.item[field.key] && this.props.item[field.key].displayValue;
        let internalValue = !_isEmpty(this.props.item)
            ? AppUtils.isDefined(fieldDisplayValue)
                ? this.props.item[field.key].displayValue
                : this.props.item[field.key]
            : null;
        // let displayObj = field.dropdownConfiguration.options.find((option: any) => option.internalValue === internalValue);
        // let displayValue = internalValue;
        // if (displayObj) {
        //     displayValue = displayObj.displayValue;
        // }
        // let validationText = this.props.validations && this.props.validations[field.key] ? this.props.validations[field.key].errorMessage : "";
        let selectedValue: string = "", selectedSuggestionValue: string = "";
        let dropDownOptions = field.dropdownConfiguration.options || [];
        if (field.parent) {
            const filterConstriant = this.props.item[field.parent];
            dropDownOptions = dropDownOptions.filter((option: any) => (Array.isArray(option.dependant) && option.dependant.indexOf(filterConstriant) > -1 || !option.dependant));
        } else {
            if (internalValue) {
                if (!_isEmpty(field.suggestions)) {
                    const suggestionSelectedOption = field.suggestions.find((option: ISelect) => option.internalValue === this.props.item[field.key]);
                    if (suggestionSelectedOption) {
                        selectedSuggestionValue = suggestionSelectedOption.internalValue
                    }
                }
                let selectedDropdownOption = field.dropdownConfiguration.options.find((option: ISelect) => option.internalValue === this.props.item[field.key]);
                if (selectedDropdownOption) {
                    selectedValue = selectedDropdownOption.displayValue;
                }
            }
        }
        return <CustomSelect
            widgetName={this.props.widgetName}
            disabled={this.props.isViewOnly}
            dropdownValues={dropDownOptions}
            keyName={field.key}
            defaultValue={field.defaultValue}
            selectedValue={selectedValue}
            updateDropdownValue={(input, keyName, isSuggestionSelected) => this.dropDownHandler(input, field.key, isSuggestionSelected)}
            suggestions={field.suggestions ? field.suggestions : []}
            selectedSuggestionValue={selectedSuggestionValue}
        />
    }

    renderToggleButton = (field: any, index: number) => {
        let value = this.props.item[field.key]
        return <input type="button" value={field.value} className={`yesOrNoButton ${value ? "active" : ""}`} onClick={() => this.toggleHandler(value, field.key)} />
    }

    renderTextField = (field: any, index: number) => {
        let displayValue = this.props.item && this.props.item[field.key] && this.props.item[field.key].displayValue;
        let value = displayValue ? this.props.item[field.key].displayValue : this.props.item[field.key];
        let validationText = this.props.validations && this.props.validations[field.key] ? this.props.validations[field.key].errorMessage : "";
        let arrItem = displayValue ? this.props.item[field.key].displayValue : this.props.item[field.key];
        const isDuplicate = this.props.items && this.props.index
            && this.props.items.findIndex((obj: any) => _isEqual(obj[field.key], this.props.item[field.key])) !== this.props.index
        if (Array.isArray(arrItem)) {
            return <CustomSelect keyName={field.key} widgetName={this.props.widgetName} disabled={this.props.isViewOnly} dropdownValues={arrItem} defaultValue={field.defaultValue} selectedValue={""} updateDropdownValue={(input) => this.dropDownHandler(input, field.key)} />
        } else {
            return <TextInput
                widgetName={this.props.widgetName}
                disabled={this.props.isViewOnly}
                validationText={validationText}
                name={field.key}
                keyName={field.key}
                value={value || ""}
                placeholder={field.placeholder}
                onChange={(value) => this.changeHandler(value, field)}
                suggestions={field.suggestions}
                onClickHandler={(event: any, data) => this.handleTextInputClick(event, { ...data, field: field.key })}
                customClasses={isDuplicate ? "is-duplicate" : undefined} />
        }
    }

    handleTextInputClick = (event: any, data?: { inputType: string, inputValue?: string | number, field?: string }) => {
        if (this.props.basic?.handleListItemClick) {
            this.props.basic.handleListItemClick(event, data)
        }
    }

    renderNumericInput = (field: any, index: number) => {
        let value = AppUtils.isDefined(this.props.item[field.key]) ? this.props.item[field.key] : null;
        const validationText = isNaN(Number(value)) ? "Only Numeric Inputs are Allowed" : undefined
        return <TextInput
            widgetName={this.props.widgetName}
            name={field.key} onChangeCallbackMeta={field.key} value={value} placeholder={field.placeholder} onChange={this.onNumericChangeHandler} validationText={validationText} />;
    }

    renderTemplatedLIst = (field: any, index: number) => {
        let disableFields = field.mappedKey && _isEmpty(this.props.item[field.mappedkey]);
        const { templatedListConfiguration } = field;
        let { showHeaderOnFields, validations } = this.props;
        validations = validations && validations.items && validations.items.length > 0 ? validations.items : [];
        return <TemplatedList
            templateName={"genericItemEditor"}
            commonProps={{ fields: field.fields, disableFields, showHeaderOnFields }}
            defaultItem={this.createDefaultItem(field)}
            listItems={this.getListItems(this.props.item)}
            validations={validations}
            templatedListValidations={this.templatedListValidations}
            isViewOnly={this.props.isViewOnly}
            onItemRemove={this.onTemplateListRemove}
            onItemChange={this.onTemplateListChange}
            hideRemoveBtn={_get(templatedListConfiguration, "hideRemoveBtn")}
            autoAddNewRow={_get(templatedListConfiguration, "autoAddNewRow")}
            addRowText={_get(templatedListConfiguration, "addRowText")}
            preventRowAddition={_get(templatedListConfiguration, "preventRowAddition")}
            key={index}
            item={this.props.item}
        />
    }

    renderTextArea = (field: any, index: number) => {
        let value = this.props.item && this.props.item[field.key];
        let { disableFields } = this.props;
        let joinValue = "";
        try {
            if (Array.isArray(value)) {
                value.forEach(element => {
                    joinValue += "-" + element.displayValue + "\n";
                });
                return <TextAreaAutoResize className={`textarea-input form-control ${this.props.basic.className}`} disabled={disableFields} name={field.key} value={joinValue || ""} placeholder={field.placeholder} onChange={(value: React.SyntheticEvent<HTMLTextAreaElement>) => this.changeHandler(value, field)} />
            }
            else {
                return <TextAreaAutoResize className={`textarea-input form-control ${this.props.basic.className}`} disabled={disableFields} name={field.key} value={value || ""} placeholder={field.placeholder} onChange={(value: ChangeEvent<HTMLTextAreaElement>) => this.changeHandler(value, field)} />
            }


        } catch (error) {
            console.error(error);
        }
        // let validationText = this.props.validations && this.props.validations[field.key] ? this.props.validations[field.key].errorMessage : ""
        // return <TextAreaAutoResize className={`textarea-input form-control ${this.props.basic.className}`} disabled={disableFields} name={field.key} value={value || ""} placeholder={field.placeholder}  onChange={(value) => this.changeHandler(value, field.key)} />

    }

    renderCheckBox = (field: any, index: number) => {
        let value = this.props.item[field.key] ? this.props.item[field.key] : false;
        return <input type="checkbox" value={value}
            className={`yesOrNoButton checkSelect ${value ? "active" : ""}`}
            onChange={(event) => this.onCheckBoxChange(event, field.key)} checked={value}
        />
    }

    renderGoalCharts = () => {
        let rows: any = [];
        return <div className={"goal-chart-container"}>
            <GoalChartComponent currentValue={""} averageValue={""}
                rows={rows} chartName={`metric-chart-${new Date().getTime()}`}
                rootClass={"patient-health-targets-chart"} subClass={"metric"}
                title={""} key={`chart-component`} />
        </div>

    }

    renderHorizontalTable = () => {
        const rowInfos = [
            { "displayName": "Sessions", "key": "sessions" },
            { "displayName": "Milestones", "key": "milestones" },
            { "displayName": "Recorded Values", "key": "values" }];
        // response from API
        let sessionList = ["01", "02", "03", "04", "05", "06", "07"]
        const milestones = ["1", "2", "3", "4", "5", "6", "7"];
        const recordedValues = ["1", "2", "3", "4", "5", "6", "7"];
        const obj = { sessions: sessionList, milestones: milestones, recordedValues: recordedValues }
        return <div className="horizontal-table-container">
            <div className="horizontal-table-headers">
                {rowInfos.length > 0 && <div className="header">{rowInfos[0].displayName}</div>}
                {sessionList.map((header: string, index: number) => <div key={index}>
                    <div className="header">{header}</div>
                </div>)}
            </div>
        </div>
    }

    renderDatePicker = (field: any, index: number) => {
        let date = this.props.item[field.key] ? moment(this.props.item[field.key]) : null;
        return <DatePicker
            placeholderText={"Recorded Date"}
            onChange={this.handleDateChange}
            dateFormat={AppConstants.reverseDateFormat}
            onBlur={this.handleDateOnBlur}
            selected={date || ""}
        />
    }

    renderSuggestion = (field: any, index: number) => {
        return <SuggestionTagsContainer rootClass={"past-conditions"} inline={field.inline || false} suggestions={field.filteredStaticConditions}
            onTagSelect={(selectedValue: any) => this.onConditionSuggestionAdd(selectedValue, field)} />

    }
    configRenderSuggestion = (field: any, index: number) => {
        return <SuggestionTagsContainer rootClass={"past-conditions"} inline={field.inline || false} index={index} suggestions={field.filteredStaticConditions}
            onTagSelect={(selectedValue: any) => this.onSuggestionAdd(selectedValue, field, index)} />

    }

    renderLabel = (field: any, index: number) => {
        return (<React.Fragment>
            <label className={"checkbox-label"}>{field.labelValue}</label>
            <LoaderConsumer>
                {value => value && <AppLoader className="align-loader-right" />}
            </LoaderConsumer>
        </React.Fragment>)
    }

    renderNumericLabel = (field: any, index: number) => {
        const numericIndex = this.props.templateIndex + 1;
        return <label className={"checkbox-label"}>{numericIndex}</label>
    }

    renderFrequency = (field: any, index: number) => {
        let unit = this.props.item ? this.props.item[field.key] ? this.props.item[field.key].unit : "" : "";
        let count = this.props.item ? this.props.item[field.key] ? this.props.item[field.key].count : "" : "";
        return <Frequency isFrequency={field.frequency.isDuration ? !field.frequency.isDuration : true} unit={unit}
            count={count} dropdownItems={field.frequency.unit.list} rootClass={"question"} placeholder={field.frequency.count.placeholder} onCountChange={(e) => this.countChangeHandler(e, field.key)}
            validator={field.validator}
            useDropdownValue={!_isEmpty(field.frequency.unit.list)}
            onUnitChange={(value) => this.unitChangeHandler(value, field.key)}
            onDurationChange={(value) => this.frequencyChangeHandler(value, field.key)}
            supportDecimal={AppUtils.isDefined(this.props.supportDecimal) ? this.props.supportDecimal : false} />;
    }

    renderQuestionnaire = (field: any, index: number) => {
        return field.data && field.data.map((dataObj: any, index: number) => {
            let key = dataObj.key;
            let answer = key && this.props.item && this.props.item[key] ? this.props.item[key] : null;
            return <Questionnaire key={index} question={dataObj} answer={answer}
                updateHandler={(value, subkey) => this.updateHandler(value, subkey, this.props.question.key)}
                hideComment={dataObj.hideComment ? dataObj.hideComment : true}
                validationHandler={this.props.validationHandler}
                isViewOnly={this.props.question.isViewOnly}
                modalHeaders={this.props.modalHeaders}
            />
        })
    }

    renderSelectableToggleList = (field: any, index: number) => {
        let value = this.props.isDefault
            ? []
            : AppUtils.isDefined(this.props.item && this.props.item[field.key])
                ? this.props.item[field.key]
                : null;
        const listItems = this.props.isDefault
            ? this.props.basic.suggestionList
            : field.values;
        const keyName = this.props.isDefault
            ? field.targetFieldKey
            : field.key
        return <ToggleList widgetName={this.props.widgetName} listItems={listItems} keyName={keyName} selectedItems={value} onSelectionChange={this.allSelectToggleHandler} type={field.type} />;

    }

    handleSuggestionList = (selectedItem: any, field: any, labelKey?: string) => {
        Tracker.track(EventNames.Field_Added, {
            widget: this.props.widgetName,
            consultationId: this.props.router.params && this.props.router.params.consultationId,
            section: this.props.metaData && this.props.metaData.sectionKey,
            value: AppUtils.getRecommendationTagLabel(labelKey, selectedItem),
            updatingMethod: EventNames.Tags
        })
        let updatedItem = { ...this.props.item };
        const data = labelKey ? selectedItem : selectedItem.recommendation;
        field.targetFields.forEach((targetField: any) => {
            if (targetField.defaultValue) {
                updatedItem[targetField.key] = targetField.defaultValue;
            } else if (data && AppUtils.isDefined(data[targetField.recommendationValue])) {
                if (targetField.targetValueIsObject) {
                    updatedItem[targetField.key] = {
                        displayValue: data[targetField.recommendationValue],
                        internalValue: targetField.internalValueKey ? data[targetField.internalValueKey] : data[targetField.recommendationValue]
                    };
                } else {
                    updatedItem[targetField.key] = data[targetField.recommendationValue];
                }
            }
        });
        this.props.onDataSelect({ ...updatedItem, updatingMethod: EventNames.Tags });
    }

    renderSuggestionList = (field: any, index: number) => {
        const labelKey: string = SEQUENTIAL_RECOMMENDATIONS_SECTIONS[field.recommendationKey]?.labelKey;
        return <SuggestionList
            widgetName={this.props.widgetName}
            name={field.key}
            listItems={this.props.basic.suggestionList}
            labelKey={labelKey}
            onListItemClick={(selectedItem: any) => this.handleSuggestionList(selectedItem, field, labelKey)}
        />
    }

    renderBooleanToggle = (field: any, index: number) => {
        let value = AppUtils.isDefined(this.props.item && this.props.item[field.key]) ? this.props.item[field.key] : null;
        return <ToggleList widgetName={this.props.widgetName} keyName={field.key} listItems={field.values} selectedItems={value ? value : field.defaultValue}
            onSelectionChange={this.booleanToggleHandler} type={field.type} />;
    }

    handleMultiSelectTypeAheadSelect(element: any, field: any, selectedIndex?: number, noOfKeystrokes?: number, searchKeyword: string) {
        if (!element) return;
        Tracker.track(EventNames.Field_Added, {
            consultationId: this.props.router.params && this.props.router.params.consultationId,
            widget: this.props.widgetName, section: this.props.metaData && this.props.metaData.sectionKey,
            value: element.label, rank: selectedIndex && selectedIndex + 1,
            updatingMethod: EventNames.Auto_Suggest,
            noOfKeystrokes: noOfKeystrokes,
            searchKeyword: searchKeyword || ""
        })
        let updatedItem = {};
        let currentList = this.props.item[field.key] ? this.props.item[field.key] : [];
        updatedItem = { ...this.props.item, [field.key]: [...currentList, { displayValue: element.label, internalValue: element.value }] };
        this.props.onDataChange(updatedItem);
        this.setState(prev => {
            return {
                selectedValuesInMultiSelect: [...prev.selectedValuesInMultiSelect, element.value],
                typeAheadValue: ""
            };
        })
    }

    renderMultiSelectDropdown = (field: any, index: number) => {
        let value = this.props.item && this.props.item[field.key] ? this.props.item[field.key].map(((item: any) => item.displayValue)) : [];
        return <div className="patient-diet-recall-editor">
            <div className={"food-dislikes-wrapper-container"}>
                <div className="food-dislikes-container">
                    <HorizontalTagsListView tagsStringArray={value} onTagRemove={e => this.onMultiSelectOptionsRemove(field, e)} />
                    <TypeAhead name={"common-input"} value={this.state.typeAheadValue} placeholder={field.placeholder}
                        widgetName={this.props.widgetName}
                        onTypeAheadChange={(input: string) => this.handleMultiSelectTypeAheadChange(input, field)}
                        onTypeAheadSelect={(element: any, selectedIndex: number, noOfKeystrokes: number, searchKeyword: string) => this.handleMultiSelectTypeAheadSelect(element, field, selectedIndex, noOfKeystrokes, searchKeyword)} />
                </div>
            </div>
        </div>
    }

    renderWeekdaySelector = (field: any, index: number) => {
        let selectedDays = this.props.item && !_isEmpty(this.props.item[field.key]) &&
            !_isEmpty(this.props.item[field.key][0].preferredWeekDays) ? this.props.item[field.key][0].preferredWeekDays : [];
        return <div className={"diagnostic-assessment-weekday-selector-container"}>
            <WeekdaySelector selectedDays={selectedDays} onSelect={(input: any) => this.updateWeekdays(input, field)} />
        </div>
    }

    renderAdvancedDurationComponent = (field: any) => {
        const unit = this.props.item && this.props.item[field.key] && this.props.item[field.key].unit ? this.props.item[field.key].unit : null;
        const count = this.props.item && this.props.item[field.key] && this.props.item[field.key].count ? this.props.item[field.key].count : null;
        return <AdvancedDurationComponent
            keyName={field.key}
            widgetName={this.props.widgetName}
            unit={unit}
            count={count}
            rootClass={""}
            toggleValues={field.toggleValues}
            selectionData={field.selectionData}
            unitList={field.unitList}
            onDurationChange={(duration: IFrequency) => this.handleAdvancedDurationChange(duration, field)}
            placeholder={field.placeholder}
        />
    }

    handleAdvancedDurationChange = (duration: IFrequency, field: any) => {
        let updateItem = { ...this.props.item };
        if (duration && duration.unit && (duration.unit === MedicineFrequencyType.SOS || duration.unit === "STAT")) {
            duration.count = null
        }
        if (duration && _isNull(duration.unit) && _isNull(duration.count)) {
            delete updateItem[field.key]
        } else {
            updateItem[field.key] = duration;
        }
        this.props.onDataChange(updateItem)
    }

    renderHeaderComponent = (field: any) => {
        const headerText: string = this.props.item && this.props.item[field.targetKey] ? this.props.item[field.targetKey].displayValue : "";
        const hasAdditionalInfo = this.props.item && field.displayAdditionalInfo ? field.mandateAdditionalInfo.filter((infoItem: any) => !_isEmpty(this.props.item[infoItem])).length > 0 : false;
        const isDuplicate = this.props.items && this.props.index
            && this.props.items.findIndex((obj: any) => (obj[field.targetKey].internalValue === this.props.item[field.targetKey].internalValue)) !== this.props.index
        return <div className={"header-container"}>
            <div className={`title ${isDuplicate ? "is-duplicate" : ""}`}>{headerText}</div>
            {hasAdditionalInfo && <div className={"additional-info-container"}>
                <div className={"icon"}><img src="/images/information-sign.svg" /></div>
                <div className={"info"}>
                    {field.additionalInfoSet && field.additionalInfoSet.map((config: any) => {
                        switch (config.type) {
                            case "header":
                                return <div className={"info-item brandon-bold"}>{config.value}</div>
                            case "item":
                                let value = this.props.item && this.props.item[config.key];
                                if (value) {
                                    if (config.itemType === "staticDataValue") value = value.displayValue;
                                    else if (config.itemType === "frequency") value = `${value.count} ${value.unit}`
                                    return <div className={"info-item"}>{value}</div>
                                } else return null;
                            default:
                                return null;
                        }
                    })}
                </div>
            </div>}
        </div>
    }

    handleToggleSwitch = (val: boolean, field: any) => {
        const updatedItem = { ...this.props.item };
        updatedItem[field.key] = val;
        this.props.onDataChange(updatedItem);
    }

    renderToggleSwitch = (field: any) => {
        const { configuration } = field;
        const enableStatus = this.props.item && AppUtils.isDefined(this.props.item[field.key]) ? this.props.item[field.key] : configuration.default;
        return <ToggleSwitch name={field.key} widgetName={this.props.widgetName} label={configuration.label || ""} enabled={enableStatus} onClick={(val: boolean) => this.handleToggleSwitch(val, field)} />
    }

    renderInputWithDropdownComponent = (field: any) => {
        const count = this.props.item && this.props.item[field.key] && this.props.item[field.key].count ? this.props.item[field.key].count : "";
        const unit = this.props.item && this.props.item[field.key] && this.props.item[field.key].unit ? this.props.item[field.key].unit : "";
        return <InputWithDropDownComponent
            name={field.key}
            widgetName={this.props.widgetName}
            inputValue={count}
            dropdownValue={unit}
            dropdownValues={field.dropdownConfiguration.options}
            onTextInputChange={(inputVal: string) => this.handleInputDropdownChange(inputVal, unit, field.key)}
            onDropdownChange={(selectedItem: string) => this.handleInputDropdownChange(count, selectedItem, field.key)}
            inputPlaceholder={field.inputPlaceholder}
            dropdownPlaceholder={field.dropdownPlaceholder}
            inputOptions={field.inputOptions}
        />
    }

    handleInputDropdownChange = (count: string, unit: string, key: string) => {
        let updatedItem = { ...this.props.item };
        updatedItem[key] = { count, unit };
        this.props.onDataChange(updatedItem);
    }

    renderFieldItem = (field: any, index: number) => {

        switch (field.type) {
            case FieldTypes.TYPEAHEAD:
                return this.renderFieldTypeAhead(field, index);

            case FieldTypes.DROPDOWN:
                return this.renderDropdown(field, index);

            case FieldTypes.TOGGLE_BUTTON:
                return this.renderToggleButton(field, index);

            case FieldTypes.TEXT_FIELD:
                return this.renderTextField(field, index);

            case FieldTypes.TEMPLATED_LIST:
                return this.renderTemplatedLIst(field, index);

            case FieldTypes.TEMPLATED_LIST_V3:
                return this.renderTemplatedLIst(field, index);

            case FieldTypes.TEXTAREA:
                return this.renderTextArea(field, index);

            case FieldTypes.CHECKBOX:
                return this.renderCheckBox(field, index);

            case FieldTypes.GOAL_CHART:
                return this.renderGoalCharts();

            case FieldTypes.HORIZONTAL_TABLE:
                return this.renderHorizontalTable();

            case FieldTypes.DATE_PICKER:
                return this.renderDatePicker(field, index);

            case FieldTypes.SUGGESTION:
                return this.renderSuggestion(field, index);
            case FieldTypes.CONFIG_SUGGESTION:
                return this.configRenderSuggestion(field, index);

            case FieldTypes.LABEL:
                return this.renderLabel(field, index);

            case FieldTypes.NUMERIC_LABEL:
                return this.renderNumericLabel(field, index);

            case FieldTypes.NUMERIC_INPUT:
                return this.renderNumericInput(field, index);

            case FieldTypes.FREQUENCY:
                return this.renderFrequency(field, index);

            case FieldTypes.QUESTIONNAIRE:
                return this.renderQuestionnaire(field, index);

            case FieldTypes.SELECTABLE_TOGGLE_LIST:
                return this.renderSelectableToggleList(field, index);

            case FieldTypes.MULTISELECT_DROPDOWN:
                return this.renderMultiSelectDropdown(field, index);

            case FieldTypes.BOOLEAN_TOGGLE:
                return this.renderBooleanToggle(field, index);

            case FieldTypes.WEEKDAY_SELECTOR:
                return this.renderWeekdaySelector(field, index);

            case FieldTypes.SUGGESTION_LIST:
                return this.renderSuggestionList(field, index);

            case FieldTypes.LABEL_LIST:
                return <RenderLabel labelList={field.fields} />;

            case FieldTypes.SPACING_BAR:
                return <SpacingArea />

            case FieldTypes.NEWLINE:
                return <br />

            case FieldTypes.ADVANCED_DURATION:
                return this.renderAdvancedDurationComponent(field)

            case FieldTypes.HEADER:
                return this.renderHeaderComponent(field)

            case FieldTypes.TOGGLE_SWITCH:
                return this.renderToggleSwitch(field)

            case FieldTypes.INPUT_WITH_DROPDOWN:
                return this.renderInputWithDropdownComponent(field)
        }
    }

    onTemplateListRemove = (index: number) => {
        let updatedValues = { ...this.props.item };
        updatedValues.items.splice(index, 1);
        this.props.onDataChange(updatedValues);
    }

    onTemplateListChange = (updatedValue: any, index: number) => {
        let updatedItem = { ...this.props.item };
        if (updatedItem.items) updatedItem.items[index] = updatedValue.item;
        else updatedItem["items"] = [updatedValue.item]
        this.props.onDataChange(updatedItem);
    }

    templatedListValidations = (value: any, index: number) => {
        let validation = { ...this.props.validations };
        validation["items"] = validation && validation.items ? validation.items : [];
        validation.items[index] = value;
        if (this.props.validationHandler)
            this.props.validationHandler(validation);
    }

    dropDownHandler = (value: string, key: string, isSuggestionSelected?: boolean) => {
        let updatedItem = { ...this.props.item, [key]: value };
        let validations = { ...this.props.validations };
        if (value === null && !isSuggestionSelected) updatedItem = { ...updatedItem, internalValue: null, displayValue: null }
        validations = ValidationUtils.checkValidations(updatedItem, this.props.fields, "key");
        this.props.onDataChange(updatedItem);
        if (this.props.validationHandler)
            this.props.validationHandler(validations);
    }

    render() {
        const fields = _get(this.props, "fields", []);
        let showHeaderOnFields = _get(this.props, "showHeaderOnFields", false);
        if (this.props.basic.modalResponse
            && this.props.basic.modalResponse.status
            && this.props.basic.modalResponse.modalUIConfig
            && this.props.basic.modalResponse.modalUIConfig.modalData
            && !this.state.validSelections.includes(this.props.basic.modalResponse.modalUIConfig.modalData)) {
            this.setState((prevState: any) => {
                return {
                    validSelections: [...prevState.validSelections, this.props.basic.modalResponse.modalUIConfig.modalData]
                };
            })
            this.props.updateModalUIConfig(null);
        } else if (this.props.basic.modalResponse
            && !this.props.basic.modalResponse.status
            && this.props.basic.modalResponse.modalUIConfig
            && this.props.basic.modalResponse.modalUIConfig.modalData
            && this.state.validSelections.includes(this.props.basic.modalResponse.modalUIConfig.modalData)) {
            this.setState((prevState: any) => {
                let prevSelections = prevState.validSelections;
                let index = prevSelections.indexOf(this.props.basic.modalResponse.modalUIConfig.modalData);
                prevSelections.splice(index, 1);
                return {
                    validSelections: prevSelections
                };
            })
        }
        return (
            <div className="generic-item-editor">
                {

                    fields.map((field: any, index: number) => {
                        let columnsCount = field.columnsCount ? `col-lg-${field.columnsCount}` : "";
                        let textSize = field.textSize ? field.textSize : "";
                        let inline = field.inline === false ? field.inline : true;
                        let bottom = field.position === "Bottom" ? "bottom" : "";
                        return <div key={index} className={`generic-item ${inline ? "in-blk" : ""} ${textSize} ${columnsCount} ${bottom}`}>
                            {showHeaderOnFields && field.header && <div className="heading">
                                {field.header}
                                {field.mandatory && <span className="mandatory-asterik">*</span>}
                            </div>}
                            {this.renderFieldItem(field, index)}
                        </div>
                    })
                }
            </div>
        )

    }
}

const mapDispatchToProps = (dispatch: any): IGenericItemEditorDispatchProps => {
    return {
        getTypeAheadData: (input: string, typeAheadConfig: any, shouldSendOverridenData?: boolean) => {
            return GenericActions.getTypeAheadData(input, typeAheadConfig, shouldSendOverridenData);
        },
        updateModalUIConfig: (modalUIConfig: any) => {
            return dispatch(ModalActions.updateModalUIConfig(modalUIConfig))
        }
    }
}

const mapStateToProps = (state: IAppState): { ongoingConsultation: IOngoingConsultation } => {
    return {
        ongoingConsultation: state.ongoingConsultation
    }
}

export default withRouter(connect<IGenericItemEditorStateToProps, IGenericItemEditorDispatchProps, IGenericItemEditorProps>(mapStateToProps, mapDispatchToProps)(GenericItemEditor));